import { useEffect, useState } from "react";

interface Sticker {
  name: string;
  src: string;
  animated: boolean;
}

interface StickerPickerProps {
  onSticker: (name: string) => void;
}

let cached: Sticker[] | null = null;
let listeners: (() => void)[] = [];

const stickerFetch = fetch("/stickers/stickers.json")
  .then((r) => r.json())
  .then((data: Sticker[]) => {
    cached = data;
    for (const fn of listeners) fn();
    listeners = [];
  })
  .catch(() => {});

export function subscribeStickers(fn: () => void): () => void {
  if (cached) {
    fn();
    return () => {};
  }
  listeners.push(fn);
  return () => {
    listeners = listeners.filter((l) => l !== fn);
  };
}

export function getStickerSnapshot(): number {
  return cached ? 1 : 0;
}

export function StickerPicker({ onSticker }: StickerPickerProps) {
  const [stickers, setStickers] = useState<Sticker[]>(cached ?? []);

  useEffect(() => {
    if (cached) return;
    stickerFetch.then(() => {
      setStickers(cached ?? []);
    });
  }, []);

  if (stickers.length === 0) {
    return (
      <div className="sticker-picker">
        <p className="sticker-picker-empty">Loading stickers...</p>
      </div>
    );
  }

  return (
    <div className="sticker-picker">
      {stickers.map((s) => (
        <button
          key={s.name}
          type="button"
          className="sticker-btn"
          title={s.name}
          onClick={() => onSticker(s.name)}
        >
          <img src={s.src} alt={s.name} loading="lazy" />
        </button>
      ))}
    </div>
  );
}

export function getStickerSrc(name: string): string | undefined {
  if (!cached) return undefined;
  return cached.find((s) => s.name === name)?.src;
}
